import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider, useLanguage } from "./context/LanguageContext";
import SEOHead from "./components/SEOHead";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Gallery from "./components/Gallery";
import About from "./components/About";
import Reviews from "./components/Reviews";
import Location from "./components/Location";
import Attractions from "./components/Attractions";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Reservation from "./components/Reservation";
import Footer from "./components/Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <SEOHead />
      <Header />
      <Hero />
      <Gallery />
      <About />
      <Reviews />
      <Location />
      <Attractions />
      <FAQ />
      <Contact />
      <Reservation />
      <Footer />
    </div>
  );
};

// Language route handler
const LanguageRouter = () => {
  const location = useLocation();
  const { setLanguage } = useLanguage();
  
  React.useEffect(() => {
    // Set language based on path
    if (location.pathname.startsWith('/hr')) {
      setLanguage('hr');
    } else {
      setLanguage('en');
    }
  }, [location.pathname, setLanguage]);

  return <HomePage />;
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LanguageRouter />} />
            <Route path="/hr" element={<LanguageRouter />} />
            <Route path="/hr/*" element={<LanguageRouter />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
